import React from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import {
  CoreLink,
  ImageFromField,
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
  NavigationScroll,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  FadeWrapper,
  MediaPlayerSuspense,
} from '../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../config/constants';

import './style.scss';

const NodeCampaignPage2 = ({ entity }) => {
  const campaignPage = entity.toJS();

  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = campaignPage.title[0].value;
  const body = campaignPage.body[0].processed;
  const primaryLink = campaignPage.field_link[0];
  const primaryLinkTarget = primaryLink?.options.attributes ? primaryLink.options.attributes.target : '_self';
  const secondaryLink = campaignPage.field_link_to_page[0];
  const secondaryLinkTarget = secondaryLink?.options.attributes ? secondaryLink.options.attributes.target : '_self';
  const media = campaignPage.field_media_item[0];

  return (
    <article className="CampaignPage2">
      <div className="CampaignPage2__hero">
        <NavigationScroll>
          <header>
            <div className="CampaignPage2__hero__logo">
              <CoreLink to={`/${currentLanguage}`}>
                <div className={`Header__logo__img ${currentLanguage === 'nl' ? 'nl-logo' : ''}`} />
              </CoreLink>
            </div>
          </header>
        </NavigationScroll>
        <Container large>
          <div className="row">
            <div className="col-12">
              <h1 className="CampaignPage2__hero__title">{title}</h1>
              <WysiwygField
                className="CampaignPage2__body"
                property="schema:text"
                html={body}
              />
              <div className="CampaignPage2__hero__links">
                {primaryLink && (
                  <CoreLink to={primaryLink.alias || primaryLink.uri} target={primaryLinkTarget} className="CampaignPage2__hero__links__link Button Button--cta">
                    {primaryLink.title}
                  </CoreLink>
                )}
                {secondaryLink && (
                  <CoreLink to={secondaryLink.alias || secondaryLink.uri} target={secondaryLinkTarget} className="CampaignPage2__hero__links__link__secondary Button Button--default">
                    {secondaryLink.title}
                    <div className="icon icon-arrow-right icon-variant-2" />
                  </CoreLink>
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="CampaignPage2__media">
        <div className="CampaignPage2__media__wrapper">
          {media.bundle === 'image' && (
            <ImageFromField
              field={entity.getIn(['field_media_item', 0])}
              imageStyles={Immutable.Map({
                [SCREEN_MOBILE]: 'page_hero_image_mobile',
                [SCREEN_TABLET]: 'page_hero_image_tablet',
                [SCREEN_NORMAL]: 'page_hero_image_desktop',
                [SCREEN_WIDE]: 'page_hero_image_desktop',
              })}
            />
          )}
          {(media.bundle === 'video') && (
            <MediaPlayerSuspense
              src={media.entity.field_media_video_file[0].source}
              type={media.mime_type}
              controls={['play', 'volume', 'currentTime', 'seekbar', 'fullscreen']}
              posterUrl={media.entity.field_poster[0].url}
            />
          )}
        </div>
      </div>

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  wide
                  entity={paragraph.get('entity')}
                />
              </FadeWrapper>
            );
          })}
        </div>
      )}
      {/* End of paragraphs */}
    </article>
  );
};

export default NodeCampaignPage2;
